import React, { useEffect, useState } from 'react'
import '../../assets/css/Toiawase.css'
import { birthday, checkbox1, checkbox2, contactAddress, contentOfInquery, emails, furigana, furiganaName, head2Name, headName, labels1, labels2, labels3, name, ourContract, pageTitle, personEmail, personName, personPhoneNo, phoneNo, subscriber } from '../../utils/ToiawaseText'
import { CDP_API_URL, CDP_PUBLIC_URL } from '../../utils/Constants'
import { errorMessages } from '../form/FormValidationRules'
import { useLocation, useNavigate } from 'react-router-dom'
import ToiawaseErrorMessage from '../ToiawaseErrorMessage'
import { headers } from '../../api/CDPAPI'
import axios from 'axios'
// import DatePicker from 'react-datepicker'
const ToiawaseFormPage = () => {
    const location = useLocation()
    const findLocation = window.location.href
    const [toiawaseConfirmData, setToiawaseConfirmData] = useState(location.state ? location.state.formData : {})
    const [isBack, setIsBack] = useState(location.state ? location.state.isBack : false)
    const [surNameTaro, setSurNameTaro] = useState('')
    const [givennameTaro, setGivenNameTaro] = useState('')
    const [surNameHoken, setSurNameHoken] = useState('')
    const [givennameHoken, setGivenNameHoken] = useState('')
    const [year, setYear] = useState('')
    const [month, setMonth] = useState('')
    const [day, setDay] = useState('')
    const [typeOfCalender, setTypeOfCalender] = useState('西暦')
    const [tel1, setTel1] = useState('')
    const [tel2, setTel2] = useState('')
    const [ward, setWard] = useState('')
    const [town, setTown] = useState('')
    const [apartment, setApartment] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [email, setEmail] = useState('')
    const [contract, setContract] = useState('')
    const [radio, setRadio] = useState(true)
    const [emailDisable, setEmailDisable] = useState(false)
    const [inquiryNameTaro, setInquiryNameTaro] = useState('')
    const [inquiryGivenNameTaro, setInquiryGivenNameTaro] = useState('')
    const [inquirySurNameHoken, setInquirySurNameHoken] = useState('')
    const [inquirygivennameHoken, setInquiryGivenNameHoken] = useState('')
    const [subscriberInquiry, setSubscriberInquiry] = useState('')
    const [emailInquiry, setEmailInquiry] = useState('')
    const [inquiryPhoneNo, setInquiryPhoneNo] = useState('')
    const [content, setContent] = useState('')
    const [error, setError] = useState({})
    const [checked, setChecked] = useState(false)
    const [isInputGiven, setIsInputGiven] = useState(false)
    const [checkedValue, setCheckedValue] = useState([])
    const [checkedValue1, setCheckedValue1] = useState('')
    const [checkedValue2, setCheckedValue2] = useState('')
    const [checkedBoxDisabled, setCheckedBoxDisabled] = useState('')
    const [headmssg, setHeadMssg] = useState(false)
    const navigate = useNavigate()
    // headErrorMessage //
    const headerMssg =
        (surNameTaro === null || surNameTaro === '' || surNameTaro === undefined ||
            givennameTaro === null || givennameTaro === '' || givennameTaro === undefined ||
            surNameHoken === null || surNameHoken === '' || surNameHoken === undefined ||
            givennameHoken === null || givennameHoken === '' || givennameHoken === undefined ||
            inquiryNameTaro === null || inquiryNameTaro === '' || inquiryNameTaro === undefined ||
            inquiryGivenNameTaro === null || inquiryGivenNameTaro === '' || inquiryGivenNameTaro === undefined ||
            inquirySurNameHoken === null || inquirySurNameHoken === '' || inquirySurNameHoken === undefined ||
            inquirygivennameHoken === null || inquirygivennameHoken === '' || inquirygivennameHoken === undefined ||
            year === null || year === '' || year === undefined ||
            month === null || month === '' || month === undefined ||
            day === null || day === '' || day === undefined ||
            // typeOfCalender === null || typeOfCalender === '' || typeOfCalender === undefined ||
            tel1 === null || tel1 === '' || tel1 === undefined ||
            tel2 === null || tel2 === '' || tel2 === undefined ||
            ward === null || ward === '' || ward === undefined ||
            town === null || town === '' || town === undefined ||
            apartment === null || apartment === '' || apartment === undefined ||
            contract === null || contract === '' || contract === undefined ||
            phoneNumber.length === 0 ||
            content === null || content === '' || content === undefined ||
            inquiryPhoneNo.length === 0 ||
            email.length === 0 ||
            emailInquiry.length === 0)
    const OnChangeSureNameTaro = (e) => {
        setSurNameTaro(e.target.value)
    }
    const OnChangeGivenName = (e) => {
        setGivenNameTaro(e.target.value)
    }
    const OnChangeSurNameHoken = (e) => {
        setSurNameHoken(e.target.value)
    }
    const OnChangeGivenNameHoken = (e) => {
        setGivenNameHoken(e.target.value)
    }
    const OnChangeInquiryNameTaro = (e) => {
        setInquiryNameTaro(e.target.value)
    }
    const OnChangeInquiryName = (e) => {
        setInquiryGivenNameTaro(e.target.value)
    }
    const OnChangeInquiryNameHoken = (e) => {
        setInquirySurNameHoken(e.target.value)
    }
    const OnChangeInquiryGivenHoken = (e) => {
        setInquiryGivenNameHoken(e.target.value)
    }
    const OnChangeInquiryEmail = (e) => {
        setEmailInquiry(e.target.value)
    }
    const OnChangeInquiryPhoneNo = (e) => {
        setInquiryPhoneNo(e.target.value)
    }
    const OnChangeContent = (e) => {
        setContent(e.target.value)
    }
    const OnChangeYear = (e) => {
        const re = /^[0-9\b]+$/
        if (e.target.value === '' || re.test(e.target.value)) {
            setYear(e.target.value)
        }
    }
    const OnChangeMonth = (e) => {
        setMonth(e.target.value)
    }
    const OnChangeDay = (e) => {
        setDay(e.target.value)
    }
    /* const OnChangeType = (e) => {
        setTypeOfCalender(e.target.value)
    } */
    const OnChangeTel1 = (e) => {
        setTel1(e.target.value)
    }
    const OnChangeTel2 = (e) => {
        setTel2(e.target.value)
    }
    const OnChangeWard = (e) => {
        setWard(e.target.value)
    }
    const OnChangeTown = (e) => {
        setTown(e.target.value)
    }
    const OnChangeApartment = (e) => {
        setApartment(e.target.value)
    }
    const OnChangePhoneNumber = (e) => {
        setPhoneNumber(e.target.value)
    }
    const OnChangeSubscriber = (e) => {
        setSubscriberInquiry(e.target.value)
    }
    const onChangeRadioHandler = (event) => {
        setRadio(event.target.value)
        setEmail('')
        if (event.target.value === 'false') {
            setEmailDisable(true)
        } else {
            setEmailDisable(false)
        }
    }
    const [checkedBox, setCheckedBox] = useState(false)
    const onClickOfCheckBox = (e) => {
        if (e.target.checked) {
            setChecked(true)
            setCheckedBox(true)
            setRadio('')
            setSurNameTaro('')
            setGivenNameTaro('')
            setSurNameHoken('')
            setGivenNameHoken('')
            setYear('')
            setMonth('')
            setDay('')
            setTypeOfCalender('西暦')
            setTel1('')
            setTel2('')
            setWard('')
            setTown('')
            setApartment('')
            setPhoneNumber('')
            setContract('')
            setCheckedValue([])
            setEmail('')
            setEmail('')
            setInquiryNameTaro('')
            setInquiryGivenNameTaro('')
            setInquirySurNameHoken('')
            setInquiryGivenNameHoken('')
            setSubscriberInquiry('')
            setInquiryPhoneNo('')
            setEmailInquiry('')
            setContent('')
        } else {
            setChecked(false)
            setCheckedBox(false)
        }
    }
    const OnChangeContract = (e) => {
        setContract(e.target.value)
        if (e.target.value) {
            setIsInputGiven(true)
        } else {
            setIsInputGiven(false)
        }
    }
    const onClickInputBox = (event) => {
        setCheckedValue1('')
        setCheckedValue2('')
        setContract('')
        setCheckedBoxDisabled(event.target.value)
        const isChecked = event.target.checked
        if (isChecked) {
            setCheckedBoxDisabled(event.target.value)
            setCheckedValue([...checkedValue, event.target.value])
            setInquiryNameTaro('')
            setInquiryGivenNameTaro('')
            setInquirySurNameHoken('')
            setInquiryGivenNameHoken('')
            setSubscriberInquiry('')
            setInquiryPhoneNo('')
            setEmailInquiry('')
        } else {
            const arr = checkedValue.filter((item) => {
                return item !== event.target.value
            })
            setCheckedBoxDisabled('')
            setCheckedValue(arr)
        }
    }
    const submitButtonClick = () => {
        // setData(data)
        fetchToiawaseData()
        if (headerMssg === true) {
            setHeadMssg(true)
        } else {
            setHeadMssg(false)
        }
    }
    const OnClickAutoZipCodeButton = async () => {
        const data = {
            contactZipcode1: tel1,
            contactZipcode2: tel2
        }
        await axios.post(`${CDP_API_URL}/getAddress-from-zipcode`, {
            ...data
        }, { headers: headers })
            .then(response => {
                response.data &&
                setWard(response.data.contactAddress1.replace(' ', ''))
                setTown(response.data.contactAddress2.replace(' ', ''))
            })
            .catch(error => {
                console.error(error)
                alert('検索が失敗しました。')
            })
    }
    // ---- API Integration ---- //
    const fetchToiawaseData = async () => {
        const data = {
            checkFlag: checkedBox,
            lastNameKanji_1: surNameTaro,
            firstNameKanji_1: givennameTaro,
            lastNameKana_1: surNameHoken,
            firstNameKana_1: givennameHoken,
            calendarType: typeOfCalender,
            birthYear: year,
            birthMonth: month,
            birthDate: day,
            contactZipcode1: tel1,
            contactZipcode2: tel2,
            contactAddress1: ward,
            contactAddress2: town,
            contactAddress3: apartment,
            telephone_1: phoneNumber,
            certificateNumberTextInput: contract,
            certificateNumberChkboxInput: checkedValue,
            isEmailPresent: radio,
            emailId_1: email,
            firstNameKanji_2: inquiryGivenNameTaro,
            lastNameKanji_2: inquiryNameTaro,
            firstNameKana_2: inquirySurNameHoken,
            lastNameKana_2: inquirygivennameHoken,
            relationshipWithSubscriber: subscriberInquiry,
            telephone_2: inquiryPhoneNo,
            emailId_2: emailInquiry,
            remarks: content
        }
        try {
            const response = await fetch(`${CDP_API_URL}/toiawase-validate-names`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(data)
            })
            const data1 = await response.json()
            const newError = {}
            data1.systemMessages.forEach(item => {
                if (item.messageCode === 'datavalidated') {
                    const InputData = {
                        checkFlag: checkedBox,
                        lastNameKanji_1: surNameTaro,
                        firstNameKanji_1: givennameTaro,
                        lastNameKana_1: surNameHoken,
                        firstNameKana_1: givennameHoken,
                        calendarType: typeOfCalender,
                        birthYear: year,
                        birthMonth: month,
                        birthDate: day,
                        contactZipcode1: tel1,
                        contactZipcode2: tel2,
                        contactAddress1: ward,
                        contactAddress2: town,
                        contactAddress3: apartment,
                        telephone_1: phoneNumber,
                        certificateNumberTextInput: contract,
                        certificateNumberChkboxInput: checkedValue,
                        isEmailPresent: radio,
                        emailId_1: email,
                        firstNameKanji_2: inquiryGivenNameTaro,
                        lastNameKanji_2: inquiryNameTaro,
                        firstNameKana_2: inquirygivennameHoken,
                        lastNameKana_2: inquirySurNameHoken,
                        relationshipWithSubscriber: subscriberInquiry,
                        telephone_2: inquiryPhoneNo,
                        emailId_2: emailInquiry,
                        remarks: content,
                        url: findLocation.toString().includes('inquiry') && 'inquiry'
                    }
                    navigate(`${CDP_PUBLIC_URL}/inquiry/confirm`, { state: InputData })
                } else if (item.messageCode === 'SVC_10_400_21') {
                    newError.kanjiIfEmpty = errorMessages.kanjiIfEmpty
                } else if (item.messageCode === 'SVC_10_400_22') {
                    newError.fullWidthcharOrAlphabetKanji = errorMessages.fullWidthcharOrAlphabetKanji
                } else if (item.messageCode === 'SVC_10_400_36') {
                    newError.overLimitedKanji = errorMessages.overLimitedKanji
                } else if (item.messageCode === 'SVC_10_400_25') {
                    newError.kanaIfEmpty = errorMessages.kanaIfEmpty
                } else if (item.messageCode === 'SVC_10_400_38') {
                    newError.overLimitedkana = errorMessages.overLimitedkana
                } else if (item.messageCode === 'SVC_10_400_26') {
                    newError.FormatKana = errorMessages.FormatKana
                } else if (item.messageCode === 'SVC_10_400_18') {
                    newError.birthlimit = errorMessages.birthlimit
                } else if (item.messageCode === 'SVC_10_500_7') {
                    newError.birthIfEmpty = errorMessages.birthIfEmpty
                } else if (item.messageCode === 'SVC_10_500_12') {
                    newError.birthYearLimit = errorMessages.birthYearLimit
                } else if (item.messageCode === 'SVC_10_400_19') {
                    newError.birthIfEmpty = errorMessages.birthIfEmpty
                } else if (item.messageCode === 'SVC_10_400_20') {
                    newError.birthIfEmpty = errorMessages.birthIfEmpty
                } else if (item.messageCode === 'SVC_10_400_29') {
                    newError.invalidIfEmpty = errorMessages.invalidIfEmpty
                } else if (item.messageCode === 'SVC_10_400_30_1') {
                    newError.insufficientInputZipCode3 = errorMessages.insufficientInputZipCode3
                } else if (item.messageCode === 'SVC_10_400_30_2') {
                    newError.insufficientInputZipCode4 = errorMessages.insufficientInputZipCode4
                } else if (item.messageCode === 'SVC_10_400_31') {
                    newError.IfNotHalfWidthNumber = errorMessages.IfNotHalfWidthNumber
                } else if (item.messageCode === 'SVC_10_400_32') {
                    newError.TelophoneIfEmpty = errorMessages.TelophoneIfEmpty
                } else if (item.messageCode === 'SVC_10_400_33') {
                    newError.ifNotHalfWidthNumber = errorMessages.ifNotHalfWidthNumber
                } else if (item.messageCode === 'SVC_10_400_37') {
                    newError.telephoneLimit = errorMessages.telephoneLimit
                } else if (item.messageCode === 'SVC_10_400_34') {
                    newError.IfEmptyEmail = errorMessages.IfEmptyEmail
                } else if (item.messageCode === 'SVC_10_400_35') {
                    newError.isEmailFormat = errorMessages.isEmailFormat
                } else if (item.messageCode === 'SVC_10_400_39') {
                    newError.isEmailLimit = errorMessages.isEmailLimit
                } else if (item.messageCode === 'SVC_10_500_1') {
                    newError.IfEmptyCertificate = errorMessages.IfEmptyCertificate
                } else if (item.messageCode === 'SVC_10_500_2') {
                    newError.lengthCertificate = errorMessages.lengthCertificate
                } else if (item.messageCode === 'SVC_10_500_3') {
                    newError.formatCertificate = errorMessages.formatCertificate
                } else if (item.messageCode === 'SVC_10_400_38') {
                    newError.overLimited = errorMessages.overLimited
                } else if (item.messageCode === 'SVC_10_500_5') {
                    newError.Address1Range = errorMessages.Address1Range
                } else if (item.messageCode === 'SVC_10_500_21') {
                    newError.Address2Range = errorMessages.Address2Range
                } else if (item.messageCode === 'SVC_10_500_22') {
                    newError.Address3Range = errorMessages.Address3Range
                } else if (item.messageCode === 'SVC_10_500_4') {
                    newError.Address1IfEmpty = errorMessages.Address1IfEmpty
                } else if (item.messageCode === 'SVC_10_500_6') {
                    newError.Address1Format = errorMessages.Address1Format
                } else if (item.messageCode === 'SVC_10_500_23') {
                    newError.Address2Format = errorMessages.Address2Format
                } else if (item.messageCode === 'SVC_10_500_24') {
                    newError.Address3Format = errorMessages.Address3Format
                } else if (item.messageCode === 'SVC_10_500_9') {
                    newError.isRemarkLimit = errorMessages.isRemarkLimit
                } else if (item.messageCode === 'SVC_10_500_10') {
                    newError.RelationNotFullWidth = errorMessages.RelationNotFullWidth
                } else if (item.messageCode === 'SVC_10_500_11') {
                    newError.isRelationLimit = errorMessages.isRelationLimit
                } else if (item.messageCode === 'SVC_10_500_13') {
                    newError.NotFullWidthKanji02 = errorMessages.NotFullWidthKanji02
                } else if (item.messageCode === 'SVC_10_500_14') {
                    newError.isOverLimitKanji = errorMessages.isOverLimitKanji
                } else if (item.messageCode === 'SVC_10_500_15') {
                    newError.isOverLimitKana = errorMessages.isOverLimitKana
                } else if (item.messageCode === 'SVC_10_500_16') {
                    newError.InvalidInputKana = errorMessages.InvalidInputKana
                } else if (item.messageCode === 'SVC_10_500_17') {
                    newError.IfNotHalfWidthNumberTelephone = errorMessages.IfNotHalfWidthNumberTelephone
                } else if (item.messageCode === 'SVC_10_500_18') {
                    newError.isOverLimitTelephoneLength = errorMessages.isOverLimitTelephoneLength
                } else if (item.messageCode === 'SVC_10_500_19') {
                    newError.IfNoEmail2 = errorMessages.IfNoEmail2
                } else if (item.messageCode === 'SVC_10_500_20') {
                    newError.isOverLimitEmail2 = errorMessages.isOverLimitEmail2
                } else if (item.messageCode === 'SVC_10_500_9_1') {
                    newError.remarkBlankCheck = errorMessages.remarkBlankCheck
                }
                window.scrollTo(0, 0)
            })
            setError(newError)
        } catch (error) {
        }
    }
    useEffect(() => {
        document.title = pageTitle
        if (isBack && toiawaseConfirmData) {
            setCheckedBox(toiawaseConfirmData.checkFlag)
            setRadio(toiawaseConfirmData.isEmailPresent)
            setSurNameTaro(toiawaseConfirmData.lastNameKanji_1)
            setGivenNameTaro(toiawaseConfirmData.firstNameKanji_1)
            setSurNameHoken(toiawaseConfirmData.lastNameKana_1)
            setGivenNameHoken(toiawaseConfirmData.firstNameKana_1)
            setYear(toiawaseConfirmData.birthYear)
            setMonth(toiawaseConfirmData.birthMonth)
            setDay(toiawaseConfirmData.birthDate)
            setTypeOfCalender(toiawaseConfirmData.calendarType)
            setTel1(toiawaseConfirmData.contactZipcode1)
            setTel2(toiawaseConfirmData.contactZipcode2)
            setWard(toiawaseConfirmData.contactAddress1)
            setTown(toiawaseConfirmData.contactAddress2)
            setApartment(toiawaseConfirmData.contactAddress3)
            setPhoneNumber(toiawaseConfirmData.telephone_1)
            setContract(toiawaseConfirmData.certificateNumberTextInput)
            setCheckedValue(toiawaseConfirmData.certificateNumberChkboxInput)
            setCheckedValue1(toiawaseConfirmData.certificateNumberChkboxInput.length > 0 && toiawaseConfirmData.certificateNumberChkboxInput[0])
            setCheckedValue2(toiawaseConfirmData.certificateNumberChkboxInput.length > 0 && toiawaseConfirmData.certificateNumberChkboxInput[1])
            setEmail(toiawaseConfirmData.isEmailPresent)
            setEmail(toiawaseConfirmData.emailId_1)
            setInquiryNameTaro(toiawaseConfirmData.lastNameKanji_2)
            setInquiryGivenNameTaro(toiawaseConfirmData.firstNameKanji_2)
            setInquirySurNameHoken(toiawaseConfirmData.lastNameKana_2)
            setInquiryGivenNameHoken(toiawaseConfirmData.firstNameKana_2)
            setSubscriberInquiry(toiawaseConfirmData.relationshipWithSubscriber)
            setInquiryPhoneNo(toiawaseConfirmData.telephone_2)
            setEmailInquiry(toiawaseConfirmData.emailId_2)
            setContent(toiawaseConfirmData.remarks)
            setIsBack(false)
            setToiawaseConfirmData({})
            location.state.isBack = false
            location.state.formData = {}
            window.history.replaceState({}, toiawaseConfirmData)
        }
    }, [])
    return (
        <div className="container toiawase">
            <div className="row">
                <div className="toiawase-input-section-inputdetails">
                    <div className="card-container-inputdetails row">
                        <h1 className="h1Style01">お問い合わせ</h1>
                        {(headmssg === true)
                            ? <div className="txt-01">
                                <p><em>入力に不備がありますので、再度ご確認ください。</em></p>
                                <p><em className="star">★</em>のある項目は、すべてご入力ください。<br></br>半角カナ,「’」,「”」,「，」は、ご使用できません。<br></br>正しい情報が送れない場合があります。<br></br>ご入力いただいた内容については、別途担当者より確認させていただく場合がございますのであらかじめご了承願います。</p>
                            </div>
                            : ''}
                        <div className="col-12">
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="toiawase-inputtext" className="col-sm-12 head1">{headName}</label>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-12 head2">{head2Name}<input type="checkbox" id='checkBox' onClick={onClickOfCheckBox} checked={checkedBox} /><br></br>
                                （匿名でのお申し出の場合、弊社から連絡を差し上げることができません。弊社からのご連絡が必要な場合は匿名ではなく連絡先の明記をお願いいたします。）</label>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-12 col-form-label1">{labels1}</label>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <div className="col-sm-3 col-form-label1">
                                    <label htmlFor="inputtext">{name}<em className="star" style={{ display: checked ? 'none' : 'initial' }}>※必須</em></label>
                                </div>
                                <div className="col-sm-12 col-md-9 col-lg-9 formMargin p-15">
                                    <span className="note">（全角でご入力ください　例：保険　太郎）</span><br></br>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6 col-lg-5 p-6">
                                                <label htmlFor="inputtext" className='form-text-02'>姓:</label>
                                                <input type="text" id="sureNameTaro" onChange={(e) => OnChangeSureNameTaro(e)} value={surNameTaro} disabled={checked || checkedBox} />
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-5 p-6">
                                                <label htmlFor="inputtext" id='label1' className='form-text-02 nametaro'>名:</label>
                                                <input type="text" id="givenNameTaro" onChange={(e) => OnChangeGivenName(e)} value={givennameTaro} disabled={checked || checkedBox} />
                                            </div>
                                            <div className="errDisplayArea">
                                                <ToiawaseErrorMessage errorMessage={error.overLimitedKanji}></ToiawaseErrorMessage>
                                                <ToiawaseErrorMessage errorMessage={error.kanjiIfEmpty}></ToiawaseErrorMessage>
                                                <ToiawaseErrorMessage errorMessage={error.fullWidthcharOrAlphabetKanji}></ToiawaseErrorMessage>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{furigana}<em className="star" style={{ display: checked ? 'none' : 'initial' }}>※必須</em></label>
                                <div className="col-sm-12 col-md-9 col-lg-9 formMargin p-15">
                                    <span className="note">（全角でご入力ください　例：ホケン　タロウ）</span><br></br>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6 col-lg-5 p-6">
                                                <label htmlFor="inputtext" className='form-text-02'>姓:</label>
                                                <input type="text" onChange={(e) => OnChangeSurNameHoken(e)} value={surNameHoken} disabled={checked || checkedBox} />
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-5 p-6">
                                                <label htmlFor="inputtext" id='label1' className='form-text-02'>名:</label><input type="text" onChange={(e) => OnChangeGivenNameHoken(e)} value={givennameHoken} disabled={checked || checkedBox} />
                                            </div>
                                            <div className="errDisplayArea">
                                                <ToiawaseErrorMessage errorMessage={error.kanaIfEmpty}></ToiawaseErrorMessage>
                                                <ToiawaseErrorMessage errorMessage={error.overLimitedkana}></ToiawaseErrorMessage>
                                                <ToiawaseErrorMessage errorMessage={error.FormatKana}></ToiawaseErrorMessage>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{birthday}<em className="star" style={{ display: checked ? 'none' : 'initial' }}>※必須</em></label>
                                <div className="col-sm-8 formMargin p-15">
                                    <span className="note">（半角数字でご入力ください。例：1234）</span>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-3 col-lg-3 dobfield">
                                            <input type="text" id="birth_era" value={typeOfCalender} disabled />
                                        </div>
                                        <div className="col-sm-12 col-md-9 col-lg-9">
                                            <input type="text" id="birth_era" onChange={OnChangeYear} value={year} disabled={checked || checkedBox} /><span id="birth_era">年</span>
                                            <select name="birth_month" id="birth_month" disabled={checked || checkedBox} onChange={(e) => OnChangeMonth(e)} value={month}>
                                                <option value="">&nbsp;</option>
                                                {Array.from({ length: 12 }, (_, index) => index + 1).map((item) => (
                                                  <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select><span id="birth_month">月</span>
                                            <select name="birth_day" id="birth_day" disabled={checked || checkedBox} onChange={(e) => OnChangeDay(e)} value={day}>
                                                <option value="">&nbsp;</option>
                                                {Array.from({ length: 31 }, (_, index) => index + 1).map((item) => (
                                                  <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select><span className="dobspan">日</span>
                                        </div>
                                        <div className="errDisplayArea">
                                            <ToiawaseErrorMessage errorMessage={error.birthIfEmpty}></ToiawaseErrorMessage>
                                            <ToiawaseErrorMessage errorMessage={error.birthYearLimit}></ToiawaseErrorMessage>
                                            <ToiawaseErrorMessage errorMessage={error.birthlimit}></ToiawaseErrorMessage>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{contactAddress}<em className="star" style={{ display: checked ? 'none' : 'initial' }}>※必須</em></label>
                                <div className="col-sm-12 col-md-8 p-15">
                                    <span className="note">（半角数字でご入力ください。例：123-4567）</span><br></br>
                                    <span htmlFor="inputtext"><label>〒</label></span><input type="text" id='text1' onChange={(e) => OnChangeTel1(e)} value={tel1} disabled={checked || checkedBox} maxLength={3} /><span>-</span>
                                    <input type="text" id='text1' onChange={(e) => OnChangeTel2(e)} value={tel2} disabled={checked || checkedBox} maxLength={4} />
                                    <button type="button" id='button' onClick={OnClickAutoZipCodeButton} disabled={checked || checkedBox}>検索</button><br></br>
                                    <div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.invalidIfEmpty}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.IfNotHalfWidthNumber}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.insufficientInputZipCode3}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.insufficientInputZipCode4}></ToiawaseErrorMessage>
                                    </div>
                                    <span className="note">市区郡　（全角30文字以内でご入力ください。　例：墨田区）</span><br></br>
                                    <input type="text" className="inputSpace" onChange={(e) => OnChangeWard(e)} value={ward} disabled={checked || checkedBox} /><br></br>
                                    <div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.Address1IfEmpty}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.Address1Range}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.Address1Format}></ToiawaseErrorMessage>
                                    </div>
                                    <span className="note">町・番地　（全角30文字以内でご入力ください。　例：太平４－１－３）</span><br></br>
                                    <input type="text" className="inputSpace" onChange={(e) => OnChangeTown(e)} value={town} disabled={checked || checkedBox} /><br></br><div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.Address2IfEmpty}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.Address2Range}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.Address2Format}></ToiawaseErrorMessage>
                                    </div>
                                    <span className="note">マンション・建物名　（全角30文字以内でご入力ください。　例：セイホビル３０１）</span><br></br>
                                    <input type="text" className="inputSpace" onChange={(e) => OnChangeApartment(e)} value={apartment} disabled={checked || checkedBox} />
                                    <div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.Address3Range}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.Address3Format}></ToiawaseErrorMessage>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{phoneNo}<em className="star" style={{ display: checked ? 'none' : 'initial' }}>※必須</em></label>
                                <div className="col-sm-12 col-md-9 col-lg-9 formMargin p-15">
                                    <span className="note">（半角数字でご入力ください。例：03-1234-5678）</span><br></br>
                                    <span className="note">※耳や言葉のご不自由なお客さまは、11-1111-1111とご入力ください。</span><br></br>
                                    <input name="tel" type="text" className="inputSpace" size="20" onChange={(e) => OnChangePhoneNumber(e)} value={phoneNumber} disabled={checked || checkedBox}></input><br></br>
                                    <span className="note">※お問い合わせの内容によっては、電話でご連絡させていただく場合もございます。</span>
                                    <div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.TelophoneIfEmpty}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.ifNotHalfWidthNumber}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.telephoneLimit}></ToiawaseErrorMessage>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{emails}<em className="star" style={{ display: checked ? 'none' : 'initial' }}>※必須</em></label>
                                <div className="col-sm-12 col-md-8 col-lg-9 formMargin p-15">
                                    <div className="row">
                                        <tbody>
                                            <tr value={radio} onClick={(e) => onChangeRadioHandler(e)}>
                                                <td id='td'><input type="radio" name='radio' value='true' defaultChecked disabled={checked || checkedBox} ></input>有</td>
                                                <td id='td'><input type="radio" name='radio' value='false' checked={radio === 'false'} disabled={checked || checkedBox}></input>無</td>
                                            </tr>
                                        </tbody>
                                        <span className="note">（半角でご入力ください　例：abcd@abcd.co.jp）</span><br></br>
                                        <input name="tel" type="text" className='email1' size="20" onChange={(event) => setEmail(event.target.value)} value={email} disabled={checked || emailDisable || checkedBox || radio === 'false'} style={{ padding: '0px' }}></input><br></br>
                                        <span className="note">※メールアドレスの入力に間違いがないよう、ご注意ください。</span>
                                        <div className="errDisplayArea">
                                            <ToiawaseErrorMessage errorMessage={error.IfEmptyEmail}></ToiawaseErrorMessage>
                                            <ToiawaseErrorMessage errorMessage={error.isEmailLimit}></ToiawaseErrorMessage>
                                            <ToiawaseErrorMessage errorMessage={error.isEmailFormat}></ToiawaseErrorMessage>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{ourContract}<em className="star" style={{ display: checked ? 'none' : 'initial' }}>※必須</em></label>
                                <div className="col-sm-12 col-md-8 col-lg-8 formMargin p-15">
                                    <div className="row">
                                        <span className="note">証券番号を半角英数字10桁でご入力ください。</span><br></br>
                                        <input type="text" className='email2' onChange={(e) => OnChangeContract(e)} value={contract} disabled={checked || (checkedValue && checkedValue.length > 0) || checkedBox} style={{ padding: '0px' }}></input><br></br>
                                        <span className="note">※証券番号の一例：2A12345678、3X11111111、6SY1234567、XSX1234567</span><br></br>
                                        <span className="note">※ご契約が複数ある場合であっても、1件のみご入力ください。</span><br></br>
                                        <tbody className="note" value={checkedValue} onChange={(e) => onClickInputBox(e)}>
                                            <tr>
                                                <td><input type="checkbox" name='checkBox1' value="証券番号が不明" disabled={checked || isInputGiven || checkedBox || contract || checkedBoxDisabled === 'ご契約がない' || checkedValue1 === 'ご契約がない'} checked={checkedValue1 === '証券番号が不明' || (checkedValue[0] === '証券番号が不明' || checkedValue[1] === '証券番号が不明')} ></input>{checkbox1}</td><br></br>
                                            </tr>
                                            <tr><td><input type="checkbox" name='checkBox2' value="ご契約がない" disabled={checked || isInputGiven || checkedBox || contract || checkedBoxDisabled === '証券番号が不明' || checkedValue1 === '証券番号が不明'} checked={checkedValue2 === 'ご契約がない' || (checkedValue[0] === 'ご契約がない' || checkedValue[1] === 'ご契約がない')}></input>{checkbox2}</td><br></br></tr>
                                        </tbody>
                                        <div className="errDisplayArea">
                                            <ToiawaseErrorMessage errorMessage={error.IfEmptyCertificate}></ToiawaseErrorMessage>
                                            <ToiawaseErrorMessage errorMessage={error.lengthCertificate}></ToiawaseErrorMessage>
                                            <ToiawaseErrorMessage errorMessage={error.formatCertificate}></ToiawaseErrorMessage>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-12 col-form-label1" style={{ background: '#f2f2f2' }}>{labels2}</label>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <div className="col-sm-3 col-form-label1">
                                    <label htmlFor="inputtext">{personName}</label>
                                </div>
                                <div className="col-sm-12 col-md-9 col-lg-9 formMargin p-15">
                                    <span className="note">（全角でご入力ください　例：保険　太郎）</span><br></br>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6 col-lg-5 p-6">
                                                <label htmlFor="inputtext">姓:</label>
                                                <input type="text" value={inquiryNameTaro} onChange={(e) => OnChangeInquiryNameTaro(e)} disabled={checked || checkedBox || checkedBoxDisabled === 'ご契約がない' || checkedValue1 === 'ご契約がない'} />
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-5 p-6">
                                                <label htmlFor="inputtext" id="label1">名:</label>
                                                <input type="text" value={inquiryGivenNameTaro} onChange={(e) => OnChangeInquiryName(e)} disabled={checked || checkedBox || checkedBoxDisabled === 'ご契約がない' || checkedValue1 === 'ご契約がない'} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.isOverLimitKanji}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.NotFullWidthKanji02}></ToiawaseErrorMessage>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <div className="col-sm-3 col-form-label1">
                                    <label htmlFor="inputtext">{furiganaName}</label>
                                </div>
                                <div className="col-sm-12 col-md-9 col-lg-9 formMargin p-15">
                                    <span className="note">（全角でご入力ください　例：ホケン　タロウ）</span><br></br>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6 col-lg-5 p-6">
                                                <label htmlFor="inputtext">姓:</label>
                                                <input type="text" value={inquirySurNameHoken} onChange={(e) => OnChangeInquiryNameHoken(e)} disabled={checked || checkedBox || checkedBoxDisabled === 'ご契約がない' || checkedValue1 === 'ご契約がない'} />
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-5 p-6">
                                                <label htmlFor="inputtext" id='label1'>名:</label><input type="text" value={inquirygivennameHoken} onChange={OnChangeInquiryGivenHoken} disabled={checked || checkedBox || checkedBoxDisabled === 'ご契約がない' || checkedValue1 === 'ご契約がない'} />
                                            </div>
                                            <div className="errDisplayArea">
                                                <ToiawaseErrorMessage errorMessage={error.isOverLimitKana}></ToiawaseErrorMessage>
                                                <ToiawaseErrorMessage errorMessage={error.InvalidInputKana}></ToiawaseErrorMessage>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{subscriber}</label>
                                <div className="col-sm-8 formMargin p-15">
                                    <input type="text" value={subscriberInquiry} onChange={(e) => OnChangeSubscriber(e)} disabled={checked || checkedBox || checkedBoxDisabled === 'ご契約がない' || checkedValue1 === 'ご契約がない'} />
                                    <div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.RelationNotFullWidth}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.isRelationLimit}></ToiawaseErrorMessage>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{personPhoneNo}</label>
                                <div className="col-sm-12 col-md-8 col-lg-9 formMargin p-15">
                                    <span className="note">（半角数字でご入力ください。例：03-1234-5678）</span><br></br>
                                    <span className="note">※耳や言葉のご不自由なお客さまは、11-1111-1111とご入力ください。</span><br></br>
                                    <input name="tel" type="text" className='inputSpace' id='email' size="20" value={inquiryPhoneNo} onChange={(e) => OnChangeInquiryPhoneNo(e)} disabled={checked || checkedBox || checkedBoxDisabled === 'ご契約がない' || checkedValue1 === 'ご契約がない'}></input><br></br>
                                    <span className="note">※お問い合わせの内容によっては、電話でご連絡させていただく場合もございます。</span>
                                    <div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.isOverLimitTelephoneLength}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.IfNotHalfWidthNumberTelephone}></ToiawaseErrorMessage>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{personEmail}</label>
                                <div className="col-sm-12 col-md-8 col-lg-9 formMargin p-15">
                                    <span className="note">（半角でご入力ください　例：abcd@abcd.co.jp）</span><br></br>
                                    <input name="tel" type="text" className='inputSpace' id='email' size="20" value={emailInquiry} onChange={(e) => OnChangeInquiryEmail(e)} disabled={checked || checkedBox || checkedBoxDisabled === 'ご契約がない' || checkedValue1 === 'ご契約がない'}></input><br></br>
                                    <span className="note">※メールアドレスの入力に間違いがないよう、ご注意ください。</span>
                                    <div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.isOverLimitEmail2}></ToiawaseErrorMessage>
                                        <ToiawaseErrorMessage errorMessage={error.IfNoEmail2}></ToiawaseErrorMessage>
                                    </div>
                                </div>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-12 col-form-label1">{labels3}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="toiawase-input-section-inputdetails">
                    <div className="card-container-inputdetails row">
                        <div className="col-12">
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-12 head1" id='head1'>{contentOfInquery}</label>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">お問い合わせ内容<em className="star" >※必須</em></label>
                                <div className="col-sm-12 col-md-9 p-15">
                                    <span className="note">（ご自由にご記入ください）</span><br></br>
                                    <textarea name="free_word" rows="20" cols="74" id="free_word" value={content} onChange={(e) => OnChangeContent(e)} style={{ width: '100%' }} maxLength="2000"></textarea>
                                    <div className="errDisplayArea">
                                        <ToiawaseErrorMessage errorMessage={error.remarkBlankCheck}></ToiawaseErrorMessage>
                                    </div>
                                    <ul className="note">
                                        <li>以下の内容につきましては、プライバシー保護の観点から、当お問い合わせ内容を介しての各種変更手続き、およびメールでのご回答は行っておりません。<br></br>（保険金・給付金等の支払い可否、受療歴などによる保険加入可否、住所変更、名義変更、契約内容照会　他お客さまの個人情報に関するお問い合わせ）</li>
                                        <li>営業目的のお問い合わせにつきましてはご対応いたしかねます。</li>
                                        <li>お電話や文書でご回答させていただく場合、また担当部門・営業店の担当者からご連絡させていいただく場合もございます。</li>
                                        <li>お問い合わせの内容によりましては、ご回答までお時間をいただく場合がございます。</li>
                                        <li>2000文字以内でご入力願います。</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="toiawase-input-section-inputdetails">
                    {/* <div className="card-container-inputdetails row"> */}
                    <div className="col-12">
                        <h2 className="h2Style01">個人情報の利用目的</h2>
                        {/* </div> */}
                    </div>
                    <div className="box-ssl-01 mbnon">
                        <p>ご入力いただきました個人情報は、お問い合わせいただいた内容に対する回答や、お客さまへのより良いサービスのご提供に向けての貴重なご意見として活用させていただきます。</p>
                        <ul className="unit-ssl equalize">
                            <dl>
                                <dd className="verisign">当サイトはお客さまの個人情報を安全に送受信するために128bit版SSL（暗号化通信）を使用しております。<br></br>
                                    <a href="http://www.metlife.co.jp/about/governance/ev-ssl/#h2Area03" className='dd'>詳細はこちらをご覧ください。</a></dd>
                            </dl>
                        </ul>
                    </div>
                    <p className="txt-confirm">上記にご同意いただける場合は、「確認」ボタンを押し、入力内容の確認へお進みください。</p>
                    <p className="form-btn-01"><input type="submit" value="確認" name="submit" className="btn-submit" onClick={submitButtonClick} /></p>
                    <div className="box-relation-01">
                        <p className="align-C mbnon"><strong>お客さま相談室<br></br>
                            0120-880-533</strong><br></br>
                            （営業時間　月～金　 9:00～17:00　祝日・年末年始除く）</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ToiawaseFormPage
